import PortfolioTradingHub from '../portfolioTradingHub';

/**
 * v2 entry for the Portfolio Trading Hub. Identical to the v1 hub except the
 * Today's Dashboard tab, which renders the shared Storybook widgets via
 * `TodaysActivityTabV2`. Reachable at `/portfolio-trading-prototype-v2`.
 */
const PortfolioTradingHubV2 = () => (
  <PortfolioTradingHub todaysTabVariant='v2' />
);

export default PortfolioTradingHubV2;
